var _div;
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Loader } from "@crehana/ui";
import { jsx as _jsx } from "react/jsx-runtime";
var LoadingOverlay = function LoadingOverlay() {
  return _div || (_div = /*#__PURE__*/_jsx("div", {
    className: "absolute top-0 left-0 flex items-center justify-center w-full h-full z-dialog bg-base-main-80",
    children: /*#__PURE__*/_jsx(Loader, {
      size: 48,
      white: true
    })
  }));
};
export default LoadingOverlay;